var common = {
  setCookie : function(cname,cvalue,exdays){
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    document.cookie = cname+"="+cvalue+"; "+expires;
  },
  getCookie : function(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i].trim();
       if (c.indexOf(name) === 0) { return c.substring(name.length,c.length); }
     }
     return "";
   },
   delCookie : function(c_name) {
     const exp = new Date();
     exp.setTime(exp.getTime() - 1);
     const cval = common.getCookie(c_name);
     if (cval != null) {
       document.cookie = c_name + '=' + cval + ';expires=' + exp.toGMTString();
     }
   }
 }
window.common = common;
export default common;



// WEBPACK FOOTER //
// ./src/util/common.js